import { render, staticRenderFns } from "./menuBar.vue?vue&type=template&id=27110001&"
import script from "./menuBar.vue?vue&type=script&lang=js&"
export * from "./menuBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/home/menu/default/aside/menuBar.vue"
export default component.exports